import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  Modal,
  Button,
  Image,
  Row,
  Col,
  CloseButton,
  ListGroup
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
const getAuthToken = () => {
  const userData = sessionStorage.getItem("userData");
  if (!userData) return "";
  try {
    const parsed = JSON.parse(userData);
    return parsed.token || "";
  } catch {
    return "";
  }
};
if (typeof document !== "undefined") {
  const styleId = "slide-right-wishlist-style";
  if (!document.getElementById(styleId)) {
    const style = document.createElement("style");
    style.id = styleId;
    style.innerHTML = `
      .modal.fade .modal-dialog.slide-right {
        transform: translateX(100%);
        transition: transform 0.3s ease-out;
      }
      .modal.show .modal-dialog.slide-right {
        transform: translateX(0);
      }
      .modal.slide-right-modal .modal-dialog {
        position: fixed;
        right: 0;
        top: 0;
        margin: 0;
        height: 100%;
        max-width: 420px;
        width: 100%;
      }
      .modal.slide-right-modal .modal-content {
        height: 100%;
        border-radius: 0;
        border: none;
        overflow-y: auto;
      }
      .wishlist-item-title {
        font-weight: 500;
        font-size: 0.95rem;
        margin-bottom: 0.2rem;
      }
      .wishlist-item-variant {
        font-size: 0.85rem;
        color: #6c757d;
      }
      .wishlist-remove {
        color: red;
        cursor: pointer;
        font-size: 0.9rem;
        margin-left: 0.5rem;
      }
      .wishlist-footer-btn {
        background-color: black;
        color: white;
        border: none;
        border-radius: 0;
        width: 100%;
        padding: 0.9rem;
        font-weight: 500;
        font-size: 1rem;
      }
      .wishlist-continue {
        text-align: center;
        display: block;
        margin-top: 1rem;
        font-size: 0.9rem;
        text-decoration: none;
        color: #6c757d;
      }
    `;
    document.head.appendChild(style);
  }
}

const WishListModal = ({ show, onHide }) => {
  const [wishlistItems, setWishlistItems] = useState([]);


  useEffect(() => {
    if (show) {
      const token = getAuthToken();
      if (!token) {
        console.warn("No auth token found for wishlist");
        return;
      }

      axios
        .get("https://vantara.datacubeglobal.com/api/wishlist", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          if (res.data.status === "success" && Array.isArray(res.data.data)) {
            const formatted = res.data.data.map((item) => ({
              id: item.product_id,
              title: item.product_name,
              mrp: item.mrp,
              image: item.primary_image
                ? `https:\/\/vantara.datacubeglobal.com\/storage/${item.primary_image}`
                : "",
            }));
            setWishlistItems(formatted);
          } else {
            setWishlistItems([]);
          }
        })
        .catch((err) => {
          console.error("Error fetching wishlist:", err);
        });
    }
  }, [show]);



const handleRemove = async (id) => {
  const token = getAuthToken();
  if (!token) {
    console.warn("No auth token found");
    return;
  }

  try {
    const response = await axios.post(
      "https://vantara.datacubeglobal.com/api/wishlist",
      { product_id: id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.data.status === true) {
      // ✅ Update UI
      setWishlistItems((prev) => prev.filter((item) => item.id !== id));

      // ✅ Show success toast
      Swal.fire({
        toast: true,
        icon: "info",
        title: "Removed from Wishlist",
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
      });
    } else {
      console.warn("Failed to remove from wishlist:", response.data);
    }
  } catch (error) {
    console.error("Error removing from wishlist:", error);
  }
};

  const navigate = useNavigate('')

  return (
    <Modal
      show={show}
      onHide={onHide}
      className="slide-right-modal fade"
      dialogClassName="slide-right"
      backdrop={true}
      keyboard={true}
    >
      <Modal.Header className="border-bottom px-4 pt-4 pb-3">
        <Modal.Title className="h5 mb-0">Wish List</Modal.Title>
        <CloseButton onClick={onHide} />
      </Modal.Header>

      <Modal.Body className="p-0">
        <ListGroup variant="flush" className="border-bottom">
          {wishlistItems.map((item) => (
            <ListGroup.Item key={item.id} className="px-4 py-3">
              <Row className="align-items-center">
                <Col xs={3}>
                  <Image src={item.image} alt={item.title} fluid rounded />
                </Col>
                <Col xs={9}>
                  <div className="d-flex justify-content-between align-items-start">
                    <div>
                      <div className="wishlist-item-title">{item.title}</div>
                      <div className="wishlist-item-variant">
                        {item.mrp}
                      </div>
                      {/* <div>
                        {item.quantity} X ${item.price.toFixed(2)}
                      </div> */}
                    </div>
                    <span
                      className="wishlist-remove"
                      onClick={() => handleRemove(item.id)}
                    >
                      Remove
                    </span>
                  </div>
                </Col>
              </Row>
            </ListGroup.Item>
          ))}
        </ListGroup>

        {/* Footer Button */}
        <div className="px-4 py-3">
          <Button className="wishlist-footer-btn" onClick={() => {
            onHide();
            navigate('/wishlist');
          }}>
            VIEW ALL WISH LIST
          </Button>
          <a href="#" className="wishlist-continue" onClick={onHide}>
            OR CONTINUE SHOPPING
          </a>
        </div>
      </Modal.Body>
      <style jsx>{`
  .wishlist-footer-btn {
    background-color:#124f14; 
    color: #fff;
    border: none;
    transition: all 0.3s ease;
  }

  .wishlist-footer-btn:hover {
    background-color: #fff; 
    color: #000; 
    border: 1px solid #000;
  }
`}</style>

    </Modal>
  );
};

export default WishListModal;
